import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { Card, CardBody, Col, Row, Container } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import columns from './components/Columns';
import MaterialTable from '../../shared/components/material-table';
import Modal from '../../shared/components/Modal';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import ShiftFilter from './components/ShiftFilter';
import GraphQL from '../../GraphQL';
import {
  shiftListByFilter,
  shiftMutationRemove,
} from '../../shared/queries/Shift';

const Shift = (props) => {
  const { t, history, dispatch } = props;
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const [lastFilter, setLastFilter] = useState({
    id: 0,
    active: true,
    filterByStatus: true,
    updaterId: 0,
  });

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const onFilterToggle = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  const loadAllShift = (filter) => {
    showLoading();
    const query = shiftListByFilter(filter || lastFilter);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        res.shiftListByFilter = res.shiftListByFilter.map(
          (item) => ({
            ...item,
            activeDescription: t(`general.yesno.${item.active}`),
          }),
          console.log('lista retornada', res.shiftListByFilter)
        );
        setData(res.shiftListByFilter);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const deleteItem = () => {
    showLoading();
    const removeMutation = shiftMutationRemove(selectedDto.id);
    GraphQL(removeMutation, {})
      .then(() => {
        hideLoading();
        toggleModal();
        loadAllShift();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
      })
      .catch(() => {
        hideLoading();
        toggleModal();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
      });
  };

  const addItemClickHandler = () => {
    setSelectedDto({ active: true, id: 0 });
    history.push('/minime/turno/mnt/0');
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    toggleModal();
  };

  const editItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      rowData,
    });
    history.push(`/minime/turno/mnt/${rowData.id}`);
  };

  const onFilterClickHandler = (filter) => {
    if (filterIsOpen) {
      onFilterToggle();
    }
    if (filter) {
      setLastFilter(filter);
      loadAllShift(filter);
    } else if (lastFilter) {
      loadAllShift(lastFilter);
    }
  };

  const filterBuildFunction = () => (
    <ShiftFilter filterClick={onFilterClickHandler} lastFilter={lastFilter} />
  );

  useEffect(() => {
    loadAllShift();
    onFilterClickHandler();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MaterialTable
                    filterBuildFunction={filterBuildFunction}
                    isFiltering={filterIsOpen}
                    filterToggle={onFilterToggle}
                    onRefreshClick={onFilterClickHandler}
                    data={data}
                    columns={columns(t)}
                    pageSize={20}
                    deleteAction={toggleModal}
                    onAddClick={addItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    onEditClick={editItemClickHandler}
                    title={t('panels.turno')}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

Shift.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(Shift)
);
